"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Points = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var ui_1 = require("components/ui");
var select_location_module_sass_1 = __importDefault(require("./select-location.module.sass"));
var YandexMap_1 = __importDefault(require("components/categories/YandexMap/YandexMap"));
var react_i18next_1 = require("react-i18next");
var SelectLocation = function (_a) {
    var _b;
    var active = _a.active, close = _a.close, style = _a.style, mobile = _a.mobile, props = __rest(_a, ["active", "close", "style", "mobile"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    var stylesWrapper = __assign({ width: "100%", height: "100%" }, style);
    var classList = (0, classnames_1["default"])(select_location_module_sass_1["default"]["select-location"], (_b = {},
        _b[select_location_module_sass_1["default"].active] = active,
        _b[select_location_module_sass_1["default"].mobile] = mobile,
        _b));
    if (!active)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classList, style: stylesWrapper }, props, { children: [!mobile && (0, jsx_runtime_1.jsx)(ui_1.Text, __assign({ size: "lg" }, { children: t("Укажите вашу локацию:") })), (0, jsx_runtime_1.jsx)(ui_1.SearchForm, { className: select_location_module_sass_1["default"].search, placeholder: t("Введите адрес"), searchPrefix: mobile, overlay: false, searchButton: !mobile, view: mobile ? "categories" : "primary" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "offset-top-20" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: select_location_module_sass_1["default"]["delete-img"] }, { children: (0, jsx_runtime_1.jsx)(YandexMap_1["default"], { data: exports.Points }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: select_location_module_sass_1["default"].close }, { children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: "close", size: mobile ? "xs" : "sm", onClick: close, cursorPointer: true }) }))] })));
};
SelectLocation.defaultProps = {
    mobile: false
};
SelectLocation.propsTypes = {
    active: prop_types_1["default"].bool.isRequired,
    close: prop_types_1["default"].func.isRequired,
    style: prop_types_1["default"].shape({}),
    mobile: prop_types_1["default"].bool
};
exports["default"] = SelectLocation;
exports.Points = [
    {
        title: "Placemark 1",
        descr: "Some description",
        coords: [55.831903, 37.411961]
    },
    {
        title: "Placemark 2",
        descr: "Some description",
        coords: [55.763338, 37.565466]
    },
    {
        title: "Placemark 3",
        descr: "Some description",
        coords: [55.763338, 37.565466]
    },
    {
        title: "Placemark 4",
        descr: "Some description",
        coords: [55.8087125, 37.79676]
    },
    {
        title: "Placemark 5",
        descr: "Some description",
        coords: [-55.780898, 37.642889]
    },
    {
        title: "Placemark 6",
        descr: "Some description",
        coords: [55.793559, 37.435983]
    },
    {
        title: "Placemark 7",
        descr: "Some description",
        coords: [55.800584, 37.675638]
    },
    {
        title: "Placemark 8",
        descr: "Some description",
        coords: [55.716733, 37.589988]
    },
];
